import { useState, useEffect, useMemo } from "react"
import { FormatDateString } from "../../utils/FormatDate"
import { GetStatusColor } from "../../utils/GetTextColor"
import axios from "axios"
import { BACKEND } from "../../config/configEnvs"
import { FaEye } from "react-icons/fa"

const ItemRowDasboardLead = ({ date, leadData, colorMap, setWorkerKPI, valoresKPIs }) => {

  const targetDate = new Date(date)
  targetDate.setHours(targetDate.getHours() + 5)

  // Valores KPIs
  const valorPerdidaLead = valoresKPIs.find((kpi) => kpi.subestado === 'Llamada perdida')?.valor || 0
  const valorLlamadaCorta = valoresKPIs.find((kpi) => kpi.subestado === 'Llamada corta')?.valor || 0
  const valorLlamadaFria = valoresKPIs.find((kpi) => kpi.subestado === 'Llamada fria')?.valor || 0
  const valorLlamadaAtendida = valoresKPIs.find((kpi) => kpi.subestado === 'Llamada atendida')?.valor || 0
  const valorMeetCancelado = valoresKPIs.find((kpi) => kpi.subestado === 'Meet cancelado')?.valor || 0
  const valorMeetReagendado = valoresKPIs.find((kpi) => kpi.subestado === 'Meet reagendado')?.valor || 0
  const valorMeetAgendado = valoresKPIs.find((kpi) => kpi.subestado === 'Meet agendado')?.valor || 0
  const valorMeetAtendido = valoresKPIs.find((kpi) => kpi.subestado === 'Meet atendido')?.valor || 0
  const valorExito = valoresKPIs.find((kpi) => kpi.subestado === 'Exito')?.valor || 0
  const valorEvaluandoOpciones = valoresKPIs.find((kpi) => kpi.subestado === 'Evaluando opciones')?.valor || 0
  const valorParaElFuturo = valoresKPIs.find((kpi) => kpi.subestado === 'Para el futuro')?.valor || 0
  const valorFrio = valoresKPIs.find((kpi) => kpi.subestado === 'Frio')?.valor || 0
  const valorPorConfirmarDeposito = valoresKPIs.find((kpi) => kpi.subestado === 'Por confirmar depósito')?.valor || 0
  const valorCurioso = valoresKPIs.find((kpi) => kpi.subestado === 'Curioso')?.valor || 0
  const valorNoResponde = valoresKPIs.find((kpi) => kpi.subestado === 'No responde')?.valor || 0
  const valorElServicioLePareceCaro = valoresKPIs.find((kpi) => kpi.subestado === 'El servicio le parece caro')?.valor || 0
  const valorDecidióTrabajarConOtraAgencia = valoresKPIs.find((kpi) => kpi.subestado === 'Decidió trabajar con otra agencia')?.valor || 0
  const valorDecidióTrabajarConUnFreelancer = valoresKPIs.find((kpi) => kpi.subestado === 'Decidió trabajar con un freelancer')?.valor || 0
  const valorNoEstaEnMiCiudad = valoresKPIs.find((kpi) => kpi.subestado === 'No esta en mi ciudad')?.valor || 0
  const valorCompetenciaOsospechoso = valoresKPIs.find((kpi) => kpi.subestado === 'Competencia o sospechoso')?.valor || 0
  const valorLeadConPocoPresupuesto = valoresKPIs.find((kpi) => kpi.subestado === 'Lead con poco presupuesto')?.valor || 0

  // Eventos

  // Eventos entrada al sistema
  const entrySystem = leadData.events?.filter(e => e.eventType === 'Entrada al sistema').length

  // Eventos llamadas
  const lostCalls = leadData.events?.filter(e => e.eventType === 'Llamada' && e.eventSubType === 'Llamada perdida').length
  const shortCalls = leadData.events?.filter(e => e.eventType === 'Llamada' && e.eventSubType === 'Llamada corta').length
  const coldCalls = leadData.events?.filter(e => e.eventType === 'Llamada' && e.eventSubType === 'Llamada fria').length
  const answeredCalls = leadData.events?.filter(e => e.eventType === 'Llamada' && e.eventSubType === 'Llamada atendida').length

  const meetScheduled = leadData.events?.filter(e => e.eventType === 'Google Meet' && e.eventSubType === 'Meet agendado').length
  const meetAttended = leadData.events?.filter(e => e.eventType === 'Google Meet' && e.eventSubType === 'Meet atendido').length
  const meetRescheduled = leadData.events?.filter(e => e.eventType === 'Google Meet' && e.eventSubType === 'Meet reagendado').length
  const meetCancelled = leadData.events?.filter(e => e.eventType === 'Google Meet' && e.eventSubType === 'Meet cancelado').length

  const frio = leadData.events?.filter(e => e.eventType === 'Cambio estado cotización' && e.eventSubType === 'Frio')
  const evaluandoOpciones = leadData.events?.filter(e => e.eventType === 'Cambio estado cotización' && e.eventSubType === 'Evaluando opciones')
  const porConfirmarDeposito = leadData.events?.filter(e => e.eventType === 'Cambio estado cotización' && e.eventSubType === 'Por confirmar depósito')
  const paraElFuturo = leadData.events?.filter(e => e.eventType === 'Cambio estado cotización' && e.eventSubType === 'Para el futuro')
  
  const curioso = leadData.events?.filter(e => e.eventType === 'Cambio estado cotización' && e.eventSubType === 'Curioso')
  const noResponde = leadData.events?.filter(e => e.eventType === 'Cambio estado cotización' && e.eventSubType === 'No responde')
  const noEstaEnMiCiudad = leadData.events?.filter(e => e.eventType === 'Cambio estado cotización' && e.eventSubType === 'No esta en mi ciudad')
  const leadConPocoPresupuesto = leadData.events?.filter(e => e.eventType === 'Cambio estado cotización' && e.eventSubType === 'Lead con poco presupuesto')
  const elServicioLePareceCaro = leadData.events?.filter(e => e.eventType === 'Cambio estado cotización' && e.eventSubType === 'El servicio le parece caro')
  const decidioTrabajarConOtraAgencia = leadData.events?.filter(e => e.eventType === 'Cambio estado cotización' && e.eventSubType === 'Decidió trabajar con otra agencia')
  const decidioTrabajarConUnFreelancer = leadData.events?.filter(e => e.eventType === 'Cambio estado cotización' && e.eventSubType === 'Decidió trabajar con un freelancer')
  const competenciaOsospechoso = leadData.events?.filter(e => e.eventType === 'Cambio estado cotización' && e.eventSubType === 'Competencia o sospechoso')

  const enExito = leadData.events?.filter(e => e.eventType === 'Cambio estado cotización' && e.eventSubType === 'Exito')

  // Ventas generales

  // En espera
  const eventosCotizacionesEnEspera = leadData.events.filter(evento => 
    evento.eventType === "Cambio estado cotización" && 
    ["Frio", "Evaluando opciones", "Por confirmar depósito", "Para el futuro"].includes(evento.eventSubType)
  );

  const eventosCotizacionesEnEsperaUnicos = [...new Set(eventosCotizacionesEnEspera.map(evento => evento.quote?.id))];

  const ventasProyectadas = eventosCotizacionesEnEsperaUnicos.reduce((acc, quoteId) => {
    const evento = eventosCotizacionesEnEspera.find(e => e.quote?.id === quoteId && e.quote?.estado === "En espera");
    return acc + (evento?.quote?.precioTotalSinIGV || 0);
  }, 0);

  // En exito
  const quotesEnExito = useMemo(() => {
    if (!leadData?.events) return [];
    return leadData.events.filter(evento => 
      evento.eventType === "Cambio estado cotización" && 
      evento.eventSubType === "Exito"
    );
  }, [leadData?.events]);

  const eventosCotizacionesEnExitoUnicos = useMemo(() => {
    const uniqueQuotes = [...new Set(quotesEnExito.map(evento => evento.quote?.id))];
    return uniqueQuotes;
  }, [quotesEnExito]);

  const ventasRealizadas = useMemo(() => {
    return eventosCotizacionesEnExitoUnicos.reduce((acc, quoteId) => {
      const evento = quotesEnExito.find(e => e.quote?.id === quoteId && e.quote?.estado === "Exito");
      return acc + (evento?.quote?.precioTotalSinIGV || 0);
    }, 0);
  }, [eventosCotizacionesEnExitoUnicos, quotesEnExito]);

  // KPI
  const totalKPI = (
    // Llamadas
    (lostCalls * valorPerdidaLead) + 
    (shortCalls * valorLlamadaCorta) + 
    (coldCalls * valorLlamadaFria) + 
    (answeredCalls * valorLlamadaAtendida) + 

    // Google Meet
    (meetScheduled * valorMeetAgendado) + 
    (meetAttended * valorMeetAtendido) + 
    (meetRescheduled * valorMeetReagendado) + 
    (meetCancelled * valorMeetCancelado) + 

    // Cotizaciones en espera
    (frio.length * valorFrio) + 
    (evaluandoOpciones.length * valorEvaluandoOpciones) + 
    (porConfirmarDeposito.length * valorPorConfirmarDeposito) + 
    (paraElFuturo.length * valorParaElFuturo) + 

    // Cotizaciones perdidas
    (curioso.length * valorCurioso) + 
    (noResponde.length * valorNoResponde) + 
    (noEstaEnMiCiudad.length * valorNoEstaEnMiCiudad) + 
    (leadConPocoPresupuesto.length * valorLeadConPocoPresupuesto) + 
    (elServicioLePareceCaro.length * valorElServicioLePareceCaro) + 
    (decidioTrabajarConOtraAgencia.length * valorDecidióTrabajarConOtraAgencia) + 
    (decidioTrabajarConUnFreelancer.length * valorDecidióTrabajarConUnFreelancer) + 
    (competenciaOsospechoso.length * valorCompetenciaOsospechoso) + 

    // Cotizaciones en exito
    (enExito.length * valorExito)
  )

  useEffect(() => {
    if (leadData.seller?.id) {
      setWorkerKPI(leadData.seller.id, totalKPI);
    }
  }, [totalKPI, leadData.seller?.id]);

  return (
    <tr className="text-xs py-2 w-full hover:bg-gray-100 transition-all duration-100">
      <td className={`${leadData.seller?.name ? "text-black" : "text-gray-200"} px-6 py-2 max-w-xs truncate border border-gray-300 text-center`}>
        {leadData.seller?.name || 'No asignado'}
      </td>
      <td className={`${leadData.lead?.leadName ? "text-black" : "text-gray-200"} px-6 py-2 max-w-xs truncate border border-gray-300 text-center`}>
        {leadData.lead?.leadName || 'Desconocido'}
      </td>
      <td className={`${leadData.lead?.leadName ? "text-black font-semibold" : "text-gray-200"} px-6 py-2 max-w-xs truncate border border-gray-300 text-center`}>
        <a 
          href={`/home/trackeoLeads/${leadData.lead.id}`} 
          className="hover:underline transition-all duration-100"
          target="_blank"
        >
          <button className="flex justify-start items-center p-1.5 rounded-md cursor-pointer bg-blue-600 text-blue-700 bg-opacity-10 hover:bg-opacity-20 hover:text-blue-700 hover:border-blue-400 transition duration-200">
            <FaEye className="text-[10px]"/>
          </button>
        </a>
      </td>
      <td className="px-6 py-2 max-w-xs truncate border border-gray-300 text-center">
        <span className={`${colorMap[leadData.lead?.status] || 'text-gray-500'}`}>
          {leadData.lead?.status || 'Sin estado'}
        </span>
      </td>
      <td className={`${!leadData.lead?.phone || leadData.lead?.phone === "Desconocido" ? "text-gray-200" : "text-black"} px-6 py-2 max-w-xs truncate border border-gray-300 text-center`}>
        {leadData.lead?.phone || '-'}
      </td>
      <td className="px-6 py-2 max-w-xs truncate border border-gray-300 text-center">
        {FormatDateString(targetDate)}
      </td>
      <td className={`${entrySystem > 0 ? "text-green-500 font-bold" : "text-gray-200"} px-6 py-2 max-w-xs truncate border border-gray-300 text-center`}>
        {entrySystem > 0 ? `Entrada - ${leadData.lead.entryOrigin}` : '-'}
      </td>
      {/* Llamadas */}
      <td className={`${lostCalls > 0 ? "text-black font-bold" : "text-gray-200"} px-6 py-2 max-w-xs truncate border border-gray-300 text-center`}>
          {lostCalls}
      </td>
      <td className={`${shortCalls > 0 ? "text-black font-bold" : "text-gray-200"} px-6 py-2 max-w-xs truncate border border-gray-300 text-center`}>
          {shortCalls}
      </td>
      <td className={`${coldCalls > 0 ? "text-black font-bold" : "text-gray-200"} px-6 py-2 max-w-xs truncate border border-gray-300 text-center`}>
          {coldCalls}
      </td>
      <td className={`${answeredCalls > 0 ? "text-black font-bold" : "text-gray-200"} px-6 py-2 max-w-xs truncate border border-gray-300 text-center`}>
          {answeredCalls}
      </td>
      {/* Google Meet */}
      <td className={`${meetScheduled > 0 ? "text-black font-bold" : "text-gray-200"} px-6 py-2 max-w-xs truncate border border-gray-300 text-center`}>
        {meetScheduled}
      </td>
      <td className={`${meetAttended > 0 ? "text-black font-bold" : "text-gray-200"} px-6 py-2 max-w-xs truncate border border-gray-300 text-center`}>
        {meetAttended}
      </td>
      <td className={`${meetRescheduled > 0 ? "text-black font-bold" : "text-gray-200"} px-6 py-2 max-w-xs truncate border border-gray-300 text-center`}>
        {meetRescheduled}
      </td>
      <td className={`${meetCancelled > 0 ? "text-black font-bold" : "text-gray-200"} px-6 py-2 max-w-xs truncate border border-gray-300 text-center`}>
        {meetCancelled}
      </td>
      {/* Cotizaciones en espera */}
      <td className={`${frio.length > 0 ? "text-black font-bold" : "text-gray-200"} px-6 py-2 max-w-xs truncate border border-gray-300 text-center`}>
        {frio.length}
      </td>
      <td className={`${evaluandoOpciones.length > 0 ? "text-black font-bold" : "text-gray-200"} px-6 py-2 max-w-xs truncate border border-gray-300 text-center`}>
        {evaluandoOpciones.length}
      </td>
      <td className={`${porConfirmarDeposito.length > 0 ? "text-black font-bold" : "text-gray-200"} px-6 py-2 max-w-xs truncate border border-gray-300 text-center`}>
        {porConfirmarDeposito.length}
      </td>
      <td className={`${paraElFuturo.length > 0 ? "text-black font-bold" : "text-gray-200"} px-6 py-2 max-w-xs truncate border border-gray-300 text-center`}>
        {paraElFuturo.length}
      </td>
      {/* Cotizaciones perdidas */}
      <td className={`${curioso.length > 0 ? "text-black font-bold" : "text-gray-200"} px-6 py-2 max-w-xs truncate border border-gray-300 text-center`}>
        {curioso.length}
      </td>
      <td className={`${noResponde.length > 0 ? "text-black font-bold" : "text-gray-200"} px-6 py-2 max-w-xs truncate border border-gray-300 text-center`}>
        {noResponde.length}
      </td>
      <td className={`${noEstaEnMiCiudad.length > 0 ? "text-black font-bold" : "text-gray-200"} px-6 py-2 max-w-xs truncate border border-gray-300 text-center`}>
        {noEstaEnMiCiudad.length}
      </td>
      <td className={`${leadConPocoPresupuesto.length > 0 ? "text-black font-bold" : "text-gray-200"} px-6 py-2 max-w-xs truncate border border-gray-300 text-center`}>
        {leadConPocoPresupuesto.length}
      </td>
      <td className={`${elServicioLePareceCaro.length > 0 ? "text-black font-bold" : "text-gray-200"} px-6 py-2 max-w-xs truncate border border-gray-300 text-center`}>
        {elServicioLePareceCaro.length}
      </td>
      <td className={`${decidioTrabajarConOtraAgencia.length > 0 ? "text-black font-bold" : "text-gray-200"} px-6 py-2 max-w-xs truncate border border-gray-300 text-center`}>
        {decidioTrabajarConOtraAgencia.length}
      </td>
      <td className={`${decidioTrabajarConUnFreelancer.length > 0 ? "text-black font-bold" : "text-gray-200"} px-6 py-2 max-w-xs truncate border border-gray-300 text-center`}>
        {decidioTrabajarConUnFreelancer.length}
      </td>
      <td className={`${competenciaOsospechoso.length > 0 ? "text-black font-bold" : "text-gray-200"} px-6 py-2 max-w-xs truncate border border-gray-300 text-center`}>
        {competenciaOsospechoso.length}
      </td>
      <td className={`${enExito.length > 0 ? "text-black font-bold" : "text-gray-200"} px-6 py-2 max-w-xs truncate border border-gray-300 text-center`}>
        {enExito.length}
      </td>
      <td className={`${ventasProyectadas > 0 ? "text-black font-bold" : "text-gray-200"} px-6 py-2 max-w-xs truncate border border-gray-300 text-center`}>
        S/. {ventasProyectadas.toLocaleString("en-US", {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2
        })}
      </td>
      <td className={`${ventasRealizadas > 0 ? "text-black font-bold" : "text-gray-200"} px-6 py-2 max-w-xs truncate border border-gray-300 text-center`}>
        S/. {ventasRealizadas.toLocaleString("en-US", {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2
        })}
      </td>
      <td className={`${totalKPI > 0 ? "text-black font-bold" : "text-gray-200"} sticky right-0 z-10 bg-white px-6 py-2 max-w-xs truncate text-center border border-gray-300 shadow-[0_0_10px_rgba(0,0,0,0.1)]`}>
        {totalKPI.toFixed(1)}
      </td>
    </tr>
  )
}

export default ItemRowDasboardLead
